var map = {
	"./ab in die schatzkasse damit.mp3": 2940,
	"./alles klar logbuch bereinigt.mp3": 7447,
	"./aye ay das gibt xp.mp3": 6638,
	"./aye das ist bares gold.mp3": 2265,
	"./aye das ist fett ebeute.mp3": 1205,
	"./aye das ist nicht irgendein fund.mp3": 8086,
	"./aye fehler aus dem logbuch gefegt.mp3": 1023,
	"./aye,sauberr fund pirat.mp3": 2047,
	"./beute an board.mp3": 5569,
	"./da draußen wartet beute.mp3": 7240,
	"./da sklimpert in der crew kasse.mp3": 7497,
	"./da steckt mehr drin als staub.mp3": 5532,
	"./danke-du-hast-pfand-sichtbar-gemacht.mp3": 4604,
	"./das ist crew material.mp3": 2731,
	"./das kommt nicht alle tage vor.mp3": 7057,
	"./das war ein flotter fang.mp3": 3203,
	"./dasist ein moment fürs logbuch.mp3": 2004,
	"./der Hafen merkt sich deinen namen.mp3": 1682,
	"./der fund war kein zufall.mp3": 9372,
	"./der hafen flüstert deinen namen.mp3": 3282,
	"./der hafen gibt was her.mp3": 9444,
	"./der kompass zittert.mp3": 7114,
	"./die crew hebt den hut.mp3": 8007,
	"./die crew merkt sich nur echte beute.mp3": 5031,
	"./die crew wird augen machen.mp3": 6890,
	"./die flasche gehört jetzt der crew.mp3": 6926,
	"./die karte wird klarer.mp3": 7095,
	"./die kiste ruft deinen namen.mp3": 330,
	"./die spur wird heiß.mp3": 1398,
	"./diese route riecht nach schatz.mp3": 1208,
	"./ein kartenstück der nebel weicht.mp3": 2144,
	"./eine feine entdeckung pirat.mp3": 2581,
	"./eintrag über board.mp3": 8530,
	"./flasche gesichert kurz stimmt.mp3": 2421,
	"./fund gesichert.mp3": 4614,
	"./gute sammler-nase pirat.mp3": 1371,
	"./gute-nachricht-deine-pfandmeldung-hat-geholfen.mp3": 3690,
	"./hehe gute beute.mp3": 6445,
	"./hoho der schatz funkelt.mp3": 2364,
	"./hoho, da glitzert was.mp3": 8782,
	"./irgendwas glitzert am horizont.mp3": 7455,
	"./jackpor vielleicht.mp3": 5542,
	"./jetzt wirds goldig.mp3": 571,
	"./kein drama das deckist wieder sauber.mp3": 1852,
	"./kleiner fund großer kurs.mp3": 977,
	"./kork hat eine spur gfunden.mp3": 7259,
	"./kork hats gewusst da lag pfand.mp3": 6820,
	"./kork nickt zufrieden.mp3": 6793,
	"./kork riecht pfand aus zehn schritte.mp3": 7082,
	"./kork sieht zeichen auf der karte.mp3": 139,
	"./kork spürt magie im hafen.mp3": 3900,
	"./kork streicht das aus der karte.mp3": 8305,
	"./korks augen funkeln schon.mp3": 6007,
	"./korrigert und abgehakt.mp3": 1604,
	"./kurs korigiert pirat.mp3": 9736,
	"./kurs setzen pirat.mp3": 4411,
	"./legendärr fund an deck.mp3": 9345,
	"./moment mal das sieht wertvoll aus.mp3": 4706,
	"./nicht shclecht die crew wird staerker.mp3": 6083,
	"./noch ein stück näher am großen fund.mp3": 4332,
	"./ordnung muss sein sogar bei piraten.mp3": 4304,
	"./pfand an deck.mp3": 1108,
	"./pfoten weg niemals.mp3": 3555,
	"./pirat du hast den richtigen riecher.mp3": 1714,
	"./quick-mark-bag-01.mp3": 5621,
	"./quick-mark-bag-02.mp3": 8722,
	"./quick-mark-bag-03.mp3": 5767,
	"./quick-mark-crate-01.mp3": 2648,
	"./quick-mark-crate-02.mp3": 2543,
	"./quick-mark-crate-03.mp3": 394,
	"./quick-mark-giveaway-01.mp3": 8830,
	"./quick-mark-giveaway-02.mp3": 4465,
	"./quick-mark-giveaway-03.mp3": 6604,
	"./quick-mark-multiple-01.mp3": 1685,
	"./quick-mark-multiple-02.mp3": 4114,
	"./quick-mark-multiple-03.mp3": 8135,
	"./quick-mark-single-01.mp3": 5245,
	"./quick-mark-single-02.mp3": 1722,
	"./quick-mark-single-03.mp3": 5311,
	"./rein damit in den sack.mp3": 1178,
	"./sauber eingesammelt pirat.mp3": 5556,
	"./schatzgeruch in der luft.mp3": 7967,
	"./schatzkiste gesichtet.mp3": 7808,
	"./seltene beute voraus.mp3": 5612,
	"./uhh seltene beute voraus.mp3": 9551,
	"./weg damit weiter segeln.mp3": 9623,
	"./wied ein stück beute weniger auf der straße.mp3": 4000,
	"./zack fund im logbuch.mp3": 9323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5353;